// src/config.ts
export const GRAPHQL_ENDPOINT = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000/graphql";

// Test-data affordances must never be offered against the production API.
export const IS_PROD_TARGET = GRAPHQL_ENDPOINT.startsWith("https://api.m4c.app");

export const CMS_MEDIA_BASE_URL = "https://m4c-cms-next-production.s3.eu-central-1.amazonaws.com";
